const zIndices = {
  dialog: 10000,
  overlay: 9999,
  top: 1,
};

export default zIndices;
